
export const amazonHost = "https://bucket.musicators.com/";


export const host = amazonHost;
export const pianoHost = host;
export const audioHost = host + "audio/";

export const memoryAudioHost = host + "memory-audio/";

export const coverHost = host + "covers/";

export const profilePictureHost = host + "avatars/";

export const assetsHost = host + "scores/";

export const generatePath = (filename: string) => {
    return assetsHost + filename;
};

export const generateAudioPath = (filename: string) => {
    return audioHost + filename;
};

export const generateGameIconPath = (filename: string) => {
    return host + "game-icon/" + filename;
};

export const christmasPath = host + "christmas-assets";

export const experienceEasterPath = amazonHost + "experience/easter";
export const experienceChristmasPath = amazonHost + "experience/christmas";